import React, { Component } from 'react'
import { connect } from 'react-redux'

import IconMenu from 'material-ui/IconMenu'
import MenuItem from 'material-ui/MenuItem'

import commentActions from 'actions/commentActions'

export class AddButton extends Component{
	render(){
		let { props } = this
		return(
			<div className="button">

				<span
					style={{
						cursor: "pointer"
					  , color: props.color || "#5ae4c3"
					}}
					onClick={()=>{props.COMMENT_ADD(props.objectID)}}
				>
					<i
						style={{
							fontSize:"22px"
						  , verticalAlign: "middle"
						  , marginRight: "5px"
						}}
						className="material-icons"
					>
						comment
					</i>
					<span style={{borderBottom: "dotted 2px " +  (props.color || "#5ae4c3")}}>COMMENT</span>
				</span>
			</div>
		)
	}
}
export default connect(null, commentActions)(AddButton)



// WEBPACK FOOTER //
// ./src/components/Comments/AddButton.js